// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__QZHE1","row":"ProcedureTreatmentSummary_row__v95AI"};